/* eslint-env browser */
'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var TLRU = require('../../utils/tlru');

var _require = require('p-queue'),
    PQueue = _require.default;

var HTTP = require('ipfs-utils/src/http'); // Avoid sending multiple queries for the same hostname by caching results


var cache = new TLRU(1000); // TODO: /api/v0/dns does not return TTL yet: https://github.com/ipfs/go-ipfs/issues/5884
// However we know browsers themselves cache DNS records for at least 1 minute,
// which acts a provisional default ttl: https://stackoverflow.com/a/36917902/11518426

var ttl = 60 * 1000; // browsers limit concurrent connections per host,
// we don't want preload calls to exhaust the limit (~6)

var httpQueue = new PQueue({
  concurrency: 4
});

var ipfsPath = function ipfsPath(response) {
  if (response.Path) return response.Path;
  throw new Error(response.Message);
};

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fqdn, opts) {
    var resolveDnslink;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // eslint-disable-line require-await
            resolveDnslink = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fqdn, opts) {
                var searchParams, query, _response, response;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        opts = opts || {};
                        searchParams = new URLSearchParams(opts);
                        searchParams.set('arg', fqdn); // try cache first

                        query = searchParams.toString();

                        if (!(!opts.nocache && cache.has(query))) {
                          _context2.next = 7;
                          break;
                        }

                        _response = cache.get(query);
                        return _context2.abrupt("return", ipfsPath(_response));

                      case 7:
                        _context2.next = 9;
                        return httpQueue.add( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                          var res, query, json;
                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return HTTP.get('https://ipfs.io/api/v0/dns', {
                                    searchParams: searchParams
                                  });

                                case 2:
                                  res = _context.sent;
                                  query = new URL(res.url).search.slice(1);
                                  _context.next = 6;
                                  return res.json();

                                case 6:
                                  json = _context.sent;
                                  cache.set(query, json, ttl);
                                  return _context.abrupt("return", json);

                                case 9:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        })));

                      case 9:
                        response = _context2.sent;
                        return _context2.abrupt("return", ipfsPath(response));

                      case 11:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function resolveDnslink(_x3, _x4) {
                return _ref2.apply(this, arguments);
              };
            }();

            return _context3.abrupt("return", resolveDnslink(fqdn, opts));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();